import React from 'react';
import Accent from '../button/accent';

import classNames from 'classnames';
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faClose,
  faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';

export const baseVariants = {
  danger: {
    className: 'banner-destructive',
    icon: faCircleExclamation,
  },
  info: {
    className: 'banner-info',
    icon: faCircleInfo,
  },
  success: {
    className: 'banner-success',
    icon: faCircleCheck,
  },
  warning: {
    className: 'banner-warning',
    icon: faTriangleExclamation,
  }
};

type BannerProps = {
  callToAction?: {
    buttonText: string;
    onClick: () => void;
    detailsText: string;
  };
  className?: string;
  content: string | React.ReactNode;
  extraVariants?: Record<string, { className: string; icon: React.ReactNode }>;
  icon?: FontAwesomeIconProps['icon'];
  noIcon?: boolean;
  show?: boolean;
  title?: string | React.ReactNode;
  variant: string;
  onClose?: () => void;
};

export default function Banner({
  callToAction,
  className,
  content,
  extraVariants,
  icon,
  noIcon = false,
  show = true,
  title,
  variant,
  onClose,
}: BannerProps) {
  if (!show) {
    return null;
  }

  const variants = { ...baseVariants, ...extraVariants };
  const variantConfig = variants[variant] || variants.info;
  icon = icon || variantConfig?.icon;

  return (
    <div className={classNames('banner align-items-center', variantConfig?.className, className)}>
      {icon && !noIcon && <FontAwesomeIcon icon={icon} size="lg"/>}

      <div className="flex-fill">
        {title && (
          <div className="title pt-0">
            <b>{title}</b>
          </div>
        )}

        <div>
          {content}
        </div>
      </div>

      {callToAction &&
        <>
          <span>{callToAction.detailsText}</span>
          <Accent outlined onClick={callToAction.onClick}>
            {callToAction.buttonText}
          </Accent>
        </>
      }

      {onClose &&
        <FontAwesomeIcon
          aria-label="close"
          icon={faClose}
          role="button"
          onClick={onClose}
        />
      }
    </div>
  );
}
